import { Injectable } from '@angular/core';
import { ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';
import {Log} from '../model/log';

@Injectable()
export class LogsService {

    constructor(private api: ApiService) { }

    findLogs(pkPortal: number, pkService: number, criteria: Object): Observable<Log[]> {

        const url = 'vna/portal/' + pkPortal + '/service/' + pkService + '/logs';

        return this.api.get(url, criteria)
            .map( (row: Array<Object>) => {
                    return row.map(function (obj) {
                        const log = new Log(obj);
                        return log;
                    })
                }
            );
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/logs/services/logs.service.ts